import { TechExperience, SEO, PageLayout } from "../components";

const TechExperiencePage = () => {
  return (
    <>
      <SEO
        url="/tech-experience"
        openGraphType="website"
        schemaType="website"
        title="Tech Experience Page"
        description="We help you transition into tech seamlessly."
      />
      <PageLayout>
        <div className="bg-[#FCFCF5] w-full">
          <TechExperience />
        </div>
      </PageLayout>
    </>
  );
};

export default TechExperiencePage;